import { IBFHistoryRecordDefinition } from "@/lib/drivers/insulet/IBFHistoryLogs/HistoryRecordParser";
import { Version } from "@/lib/drivers/insulet/OmnipodTypes";

export type IBFActivate = {
  lotNumber: number;
  seqNumber: number;
  processor: Version;
};

export const IBF_ACTIVATE = {
  value: 0x8000,
  name: "IBF_ACTIVATE",
  size: 14,
  parse: (record): IBFActivate => {
    const lotNumber = record.nextUInt32LE();
    const seqNumber = record.nextUInt32LE();
    const processor = record.nextVersion();
    return {
      lotNumber,
      seqNumber,
      processor,
    };
  },
} satisfies IBFHistoryRecordDefinition<IBFActivate>;
